<template>
  <div class='page-start'>
    <mdb-container class="col-12 pb-3" fluid>

      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
        Success! Submitted QCR Disposition!
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
          There was an error submiting your disposition for the QCR. Please try again! Error Code P2
      </mdb-alert>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p3" @closeAlert="p3=false" dismiss>
        Success! Discussion set for the selected QCR!
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
          There was an error setting the discussion for the QCR. Please try again! Error Code P4
      </mdb-alert>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p5" @closeAlert="p5=false" dismiss>
        Success! Updated QCR!
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6" @closeAlert="p6=false" dismiss>
          There was an error updating the QCR. Please try again! Error Code P6
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="info" v-if="p7" @closeAlert="p7=false" dismiss>
          There is no QIP to preview.
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p9" @closeAlert="p9=false" dismiss>
        There was an error sending the QCR back to CCB. Please try again! Error Code P9
      </mdb-alert>

     
        <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Quadrus Corporation QCRs</h3>
        <mdb-card-body>
          <mdb-row>
            <mdb-col>
              <mdb-input class="mb-0 mt-2" type="checkbox" id="showAll" v-model="showAll" name="showAll" label="Show All QCRs" @click.native.prevent="handleToggle('all')"/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-0 mt-2" type="checkbox" id="showPending" v-model="showPending" name="showPending" label="Show Pending QCRs" @click.native.prevent="handleToggle('pending')"/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-0 mt-2" type="checkbox" id="showOpen" v-model="showOpen" name="showOpen" label="Show Open QCRs" @click.native.prevent="handleToggle('open')"/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-0 mt-2" type="checkbox" id="showClosed" v-model="showClosed" name="showClosed" label="Show Closed QCRs" @click.native.prevent="handleToggle('closed')"/>
            </mdb-col>
          </mdb-row>
          <hr>
          <br>
          <h4>Advanced Filtering</h4>

          <div id="filterOptions" v-for="(item, index) in qcrFilterOptions" :key="item.id">
            <mdb-row v-if="filterNumber >= index + 1">
              <mdb-col>
                <mdb-select id="filterDropdown" class="mb-3" v-model="item.options" ref="filterDropdown" @getValue="setVal" label="Filter Options"/>    
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3" v-model="filterVal[index]" @change="setFilterVal(index, filterVal[index])" :disabled="!item.set" label="Search for"/>
              </mdb-col>
            </mdb-row>
          </div>

          <mdb-row class="offset-4">
            <mdb-col >
              <mdb-btn class="mt-4 roundButton" color="info" type="submit" v-on:click="addFilter">+</mdb-btn>  
              <mdb-btn class="mt-4 roundButton" color="info" type="submit" v-on:click="removeFilter">-</mdb-btn>  
            </mdb-col>
            <mdb-col></mdb-col>
          </mdb-row><br>

          <mdb-row>
            <mdb-col class="d-flex align-items-center justify-content-center">
              <mdb-btn size="block" class="mt-4" color="secondary" style="width: 50%;" type="submit" v-on:click="resetFilter">Clear Filter</mdb-btn>  
            </mdb-col>
            <mdb-col class="d-flex align-items-center justify-content-center">
              <mdb-btn size="block" class="mt-4 QuadrusButton" style="width: 50%;" type="submit" v-on:click="searchFilter">Apply Filter</mdb-btn>  
            </mdb-col>
          </mdb-row>
          <br><br>

          <div ref="mainTable">
            <QDataTable id='qcrTable' :rowData="this.qcrData.rowData" :filterWords="this.qcrData.filterWords" :headers="this.qcrData.columns" 
            :btnName="'Review QCR'" :hasBtn="true" @use-method='previewQCR' :hasEdit="true" :editName="'View / Edit QIP'" @edit='viewQIP'
            :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
            </QDataTable>
          </div>

          <div v-if="this.pendingQCRs.rowData.length > 0">
            <h4>Pending QCRS - Discussion Required</h4>
            <QDataTable id='qcrTable2' :rowData="this.pendingQCRs.rowData" :filterWords="this.pendingQCRs.filterWords" :headers="this.pendingQCRs.columns" 
            :btnName="'Review QCR'" :hasBtn="true" @use-method='previewQCR' :hasEdit="true" :editName="'View / Edit QIP'" @edit='viewQIP' 
            :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
            </QDataTable>
          </div>
          <div :class="{'hideSpinner': isSetUp}" class="p-4">
            <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
          </div>
        </mdb-card-body>
        </mdb-card>

        <mdb-modal size="xl" centered :show="viewModal" @close="viewModal = false;">
          <mdb-modal-header>
            <mdb-modal-title><p class="h2 grey-text">QCR Disposition CCB</p></mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body style="font-size: 0.9em; text-align: left !important;">
            <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="alreadyApproved && qcrIsPending && !discussionRequired">
              You have already submitted a disposition for this QCR.
            </mdb-alert>
            <mdb-alert id="feedback-success" class="mt-3" color="info" v-if="type == 'Open'">
              This QCR has been approved.
            </mdb-alert>
            <mdb-alert id="feedback-success" class="mt-3" color="info" v-if="type == 'Closed'">
              This QCR has been closed.
            </mdb-alert>
            <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p6_success" @closeAlert="p6_success=false" dismiss>
              Success! The QCR has been updated!
            </mdb-alert>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6_fail" @closeAlert="p6_fail=false" dismiss>
              Failed to update the QCR.
            </mdb-alert>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p7_fail" @closeAlert="p7_fail=false" dismiss>
              Failed to submit the disposition. Missing required fields.
            </mdb-alert>
            <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p5_success" @closeAlert="p5_success=false" dismiss>
              Success! A reminder email has been sent!
            </mdb-alert>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p5_fail" @closeAlert="p5_fail=false" dismiss>
              The email failed to send.
            </mdb-alert>
            <br>

            <p v-if="discussionRequired"><i>Discussion Needed for QCR Disposition CCB</i></p>

            <mdb-col v-if="(isAdmin || isPmOnProject) && type == 'Open'">
              <mdb-row class="d-flex justify-content-center">
                <mdb-btn class="m-4 QuadrusButton" type="submit" v-on:click="viewReset = true">Send QCR Back to CCB</mdb-btn>
              </mdb-row>
            </mdb-col>

            <div v-if="qcrIsPending && (this.isPM || this.isAdmin || this.isCCBOnProject) && !alreadyApproved || (isCM && discussionRequired)" class="fadeIn">
              <div v-if="!discussionRequired">
                <mdb-col>
                  <p><i>Enter comments below and select a disposition</i></p>
                </mdb-col>
                <mdb-row>
                  <mdb-col>
                    <mdb-input label='Comments' v-model="commentsCCB" outline type='textarea' :rows="6" maxlength="500"/>
                  </mdb-col>
                </mdb-row>
              </div>

              <mdb-row>
                <mdb-col class="d-flex align-items-center justify-content-center">
                  <mdb-select style="width: 50%;" label="Disposition" @getValue="setDisposition" v-model="disposition"/>
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col style="width: 50% !important; text-align: center !important;">
                  <div v-if="!dispositionSet" class="invalid-feedback d-block">Please select an option.</div>
                  <div v-else class="valid-feedback d-block">Looks Good!</div>
                </mdb-col>
              </mdb-row>
              
              <mdb-row v-if="statusOptions.length > 0 && (isPmOnProject ||isAdmin || discussionRequired)">
                <mdb-col class="d-flex align-items-center justify-content-center">
                  <mdb-select style="width: 50%;" label="Status" @getValue="setStatus" v-model="statusOptions"/>
                </mdb-col>
              </mdb-row>
              <mdb-row v-if="statusOptions.length > 0 && (isPmOnProject ||isAdmin || discussionRequired)">
                <mdb-col style="width: 50% !important; text-align: center !important;">
                  <div v-if="!qcrSelectedStatus" class="invalid-feedback d-block">Please select an option.</div>
                  <div v-else class="valid-feedback d-block">Looks Good!</div>
                </mdb-col>
              </mdb-row>
              
              
              <br>

              <div v-if="(isCCBOnProject || isPmOnProject || isAdmin) || (isCM && discussionRequired)">
                <mdb-row class="d-flex align-items-center justify-content-center">
                  <mdb-btn v-if="!discussionRequired" color="outline-mdb-color" type="submit" v-on:click="discussQCR">Discussion Needed</mdb-btn>
                  <mdb-btn class="QuadrusButton" type="submit" v-on:click="setQCRDispositionStance">Submit Disposition</mdb-btn>
                </mdb-row>
              </div>
            </div>
            <br><br>

            <!--Page 1-->
            <div>
              
              <div class="fadeIn" v-if="isPage1" style="text-align: left !important;">
                <mdb-row>
                  <mdb-col>
                    <mdb-col v-if="(isAdmin || isCM) && qcrIsPending && !discussionRequired" style="text-align: left !important; border-top: 2px solid grey; padding: 10px;">
                      <h5>CM Actions</h5>
                      <mdb-row class="d-flex justify-content-center">
                        <mdb-btn class="m-4" color="outline-default" type="submit" v-on:click="sendCCBReminder">Send CCB Reminder</mdb-btn>
                        <mdb-btn class="m-4" color="outline-danger" type="submit" v-on:click="markCCB1Complete('Disapproved')">Force Disapprove</mdb-btn>
                        <mdb-btn class="m-4" color="outline-primary" type="submit" v-on:click="markCCB1Complete('Approved')">Force Approve</mdb-btn>
                      </mdb-row>
                    </mdb-col><br>
                    
                    <mdb-col style="text-align: left !important; border-top: 2px solid grey; padding: 10px;">
                      <h5>Completion Status</h5>
                      <QDataTable id='memberTable' :rowData="this.members.rowData" :filterWords="this.members.filterWords" :headers="this.members.columns"
                      :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
                      </QDataTable>
                      <div style="text-align: center !important;" :class="{'hideSpinner': isSetUp}" class="p-4">
                        <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
                      </div>
                    </mdb-col>
                  </mdb-col>
                </mdb-row>
              </div>
          </div>


          <!--Page 2-->
          <div class="fadeIn" v-if="isPage2" style="text-align: left !important; border-top: 2px solid grey; padding: 10px;">
          <br>
          <h5>QPR Information</h5>
          <mdb-row>
            <mdb-col class="col-2">
              <mdb-input class="mb-3 readonly-inputs" v-model="qprNumber" label="QPR Number" readOnly/>
            </mdb-col>
            <mdb-col class="col-4">
              <mdb-input class="mb-3 readonly-inputs" v-model="qprSubmitDate" label="Date Created" readOnly/>
            </mdb-col>
            <mdb-col class="col-6">
              <mdb-input class="mb-3 readonly-inputs" v-model="approvingPM" label="Approving Project Manager" readOnly/>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col>
              <label>Approving Manager Comments from QPR</label>
              <mdb-input class="mb-3 no-resize-textarea" outline type='textarea' :rows="2" v-model="pmComments" readOnly />
            </mdb-col>
          </mdb-row>

          <h5>QCR Information</h5>
          <mdb-row>
            <mdb-col col="1">
              <mdb-input class="mb-3 readonly-inputs" v-model="qcrNumber" label="QCR Number" readOnly/>
            </mdb-col>
            <mdb-col col="9">
              <mdb-input class="mb-3 readonly-inputs" v-model="title" label="Title" readOnly/>
            </mdb-col>
            <mdb-col col="2">
              <mdb-input class="mb-3 readonly-inputs" v-model="author" label="Author" readOnly/>
            </mdb-col>
          </mdb-row>
          <br>
          <mdb-row>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="dateCreated" label="Date Created" readOnly/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="companyName" label="Company Name" readOnly/>
            </mdb-col>
            <mdb-col>
              <mdb-select v-if="(isPmOnProject || isAdmin) && type != 'Closed'" class="mb-3" label="Found In" @getValue="setProjects" v-model="projectOptions"/>
               <mdb-btn v-if="(isPmOnProject || isAdmin) && type != 'Closed'" :disabled="oldFoundIn == foundIn" size="block" class="mt-4" color="info" type="submit" v-on:click="submitProductChanges">Update</mdb-btn>
              <mdb-input v-else class="mb-3 readonly-inputs" v-model="foundIn" label="Found In" readOnly/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="softwareVersion" label="Software Version" readOnly />
            </mdb-col>
            
          </mdb-row>
          <mdb-row>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="foundDuring" label="Found During" readOnly/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="selectedDisposition" label="Disposition" readOnly/>
            </mdb-col>
            <mdb-col>
              <mdb-input class="mb-3 readonly-inputs" v-model="previousStatus" label="Status" readOnly />
            </mdb-col>
            <mdb-col>
              <mdb-input v-if="!(isPmOnProject || isAdmin) || !qcrIsPending" class="mb-3 readonly-inputs" v-model="priority" label="Priority" readOnly/>
              <mdb-select v-if="(isPmOnProject || isAdmin) && qcrIsPending" id="pmDropdown" class="mb-3" v-model="priorityOptions" @getValue="setPriority" label="Priority" />
              <mdb-btn v-if="(isPmOnProject || isAdmin) && qcrIsPending" :disabled="oldPriority == priority" size="block" class="mt-4" color="info" type="submit" v-on:click="submitChanges">Update</mdb-btn>
            </mdb-col>
          </mdb-row>
          <br>
          <mdb-row>
            <mdb-col>
              <label>Current Functionality</label>
              <mdb-input class="mb-3 no-resize-textarea" outline type='textarea' :rows="4" v-model="currentFunction" readOnly />
            </mdb-col>
          </mdb-row>
          <br>
          <mdb-row>
            <mdb-col>
              <label>Expected Functionality</label>
              <mdb-input outline type='textarea' :rows="4" class="mb-3 no-resize-textarea" v-model="expectedFunction" readOnly />
            </mdb-col>
          </mdb-row>
         
          </div>       
            
          </mdb-modal-body>
          <br><br>

          <mdb-modal-footer class="d-flex justify-content-between">
            <mdb-btn v-if="isPage2" color="secondary" @click.native="ccbBack">Back to CCB</mdb-btn>
            <mdb-btn v-else color="secondary" @click.native="ccbBack">Back to QCR List</mdb-btn>
            <mdb-btn v-if="isPage1" class="QuadrusButton" type="submit" v-on:click="ccbContinue">Preview QCR</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>  


        <mdb-modal size="xl" centered :show="viewReset" @close="viewReset = false" style="z-index: 99999 !important;">
            <mdb-modal-header>
              <mdb-modal-title><p class="h2 grey-text">Send QCR Back to CCB</p></mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body style="font-size: 0.9em;">
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p8_fail" @closeAlert="p8_fail=false" dismiss>
              Missing required fields.
            </mdb-alert>
              <mdb-row>
                  <mdb-col>
                    <p>This action will set the QCR disposition back to 'Pending' and require the CCB process to be completed again.</p>
                    <hr>
                    <form @submit.prevent="" class="was-validated">
                      <mdb-col>
                          <mdb-input class="mb-3" type="textarea" :rows="4" outline v-model="reasonForReset" label="Reason"
                          maxlength="500" required
                          invalid-feedback="Please Input Reason" valid-feedback="Looks Good!"/>
                      </mdb-col>
                    </form>
                </mdb-col>
              </mdb-row>
            </mdb-modal-body>

          <mdb-modal-footer class="d-flex justify-content-between">
            <mdb-btn color="secondary" @click.native="viewReset = false">Close</mdb-btn>
            <mdb-btn class="QuadrusButton" v-on:click="sendQCRBackToCCB">Submit and Reset QCR</mdb-btn>
          </mdb-modal-footer>
      </mdb-modal>

    </mdb-container>
  </div>
</template>
<style>
.roundButton {
  border: none;
  font-size: 1.5em;
  width: 15%; 
  border-radius: 25%;
  padding: .1em;
}
.no-resize-textarea > textarea {
  height: 120px !important;
  max-height: 120px !important;
  overflow-y: auto !important;
  resize: none !important;
}
.readonly-inputs input{
  cursor: text !important;
}
</style>
<script>
import { mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbBtn, mdbAlert, mdbSelect, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
import QDataTable from '@/components/QDataTable.vue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import * as PDFDownload from '@/assets/js/downloadPDF.js';
import * as QIPDownload from '@/assets/js/buildQIPsPDF.js';
import * as sendEmail from '@/assets/js/email.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

export default {
	name: 'View-QCRs',
	components: {
    mdbInput,
    mdbCard,
    mdbCardBody,
    mdbContainer,
    QDataTable,
    mdbRow,
    mdbCol, 
    mdbBtn,
    mdbAlert,
    mdbSelect,
    mdbModal, 
		mdbModalHeader, 
		mdbModalTitle, 
		mdbModalBody, 
		mdbModalFooter,
  },

  data() {
    return {
      viewModal: false,
      isPage1: false,
      isPage2: false,
      p1: false,
      p2: false,
      p3: false,
      p4: false,
      p5: false,
      p6: false,
      p7: false,
      p9: false,
      p5_success: false,
      p5_fail: false,
      p6_success: false,
      p6_fail: false,
      p7_fail: false,
      p8_fail: false,

      viewReset: false,
      reasonForReset: '',

      qcrIsPending: false,
      qipIsEditable: false,
      isSetUp: false,
      isDev: false,
      isPM: false,
      isCM: false,
      isAdmin: false,
      isCCB: false,
      isCCBOnProject: false,
      isPmOnProject: false,
      alreadyApproved: false,
      devProjects: [],
      pmProjects: [],
      disposition: [{text: "Approved", value: "Approved"},{text:"Disapproved", value: "Disapproved"}],
      statusOptions: [],
      selectedDisposition: '',
      commentsCCB: '',

      dateCreated: '',
      showClosed: false,
      showOpen: false,
      showPending: false,
      showAll: false,
      previewing: false,
      qcrNumber: '',
      title: '',
      author: '',
      foundIn: '',
      softwareVersion: '',
      foundDuring: '',
      currentFunction: '',
      expectedFunction: '',
      priority: '',
      priorityOptions: [],
      projectOptions: [],
      oldPriority: '',
      oldFoundIn: '',
      status: '',
      discussionRequired: '',
      msgIds: [],
      qcrSelectedStatus: '',
      previousStatus: '',
      QIPNumber: '',
      minimalApproval: false,
      qcrID: '',
      type: '',
      companyName: '',
      approvingPM: '',
      qprNumber: '',
      pmComments: '',
      qprSubmitDate: '',
      dispositionSet: false,
    
      filterNumber: 1,
      filterVal: ["","","","","","","",""],
      filterChoices: [],

      qcrFilterOptions: [],

      members:{
        columns: [  
          {
            colTitle: 'Name',
            sortBy: 'name'
          },
          {
            colTitle: 'CCB Dispositions',
            sortBy: 'approved'
          },
          {
            colTitle: 'Comments',
            sortBy: 'comments'
          },
        ],
        rowData: [],
        filterWords: [
          'name',
          'approved',
          'comments'
        ]
      },

      pendingQCRs:{
        columns: [  
          {
            colTitle: 'QCR Number',
            sortBy: 'QCRnumber'
          },
          {
            colTitle: 'Date Created',
            sortBy: 'dateCreated'
          },
          {
            colTitle: 'Title',
            sortBy: 'title'
          },
          {
            colTitle: 'Found In',
            sortBy: 'foundIn'
          },
          {
            colTitle: 'Software Version',
            sortBy: 'softwareVersion'
          },
          {
            colTitle: 'Found During',
            sortBy: 'foundDuring'
          },
          {
            colTitle: 'Priority',
            sortBy: 'priority'
          },
          {
            colTitle: 'Disposition',
            sortBy: 'selectedDisposition'
          },
          {
            colTitle: 'Status',
            sortBy: 'status'
          },
          {
            colTitle: 'Action',
            sortBy: ''
          },
        ],
        rowData: [],
        filterWords: [
          'QCRnumber',
          'dateCreated',
          'title',
          'foundIn',
          'softwareVersion',
          'foundDuring',
          'priority',
          'selectedDisposition',
          'status'
        ]
      },

      qcrData: {
        columns: [  
          {
            colTitle: 'QCR Number',
            sortBy: 'QCRnumber'
          },
          {
            colTitle: 'Date Created',
            sortBy: 'dateCreated'
          },
          {
            colTitle: 'Title',
            sortBy: 'title'
          },
          {
            colTitle: 'Found In',
            sortBy: 'foundIn'
          },
          {
            colTitle: 'Software Version',
            sortBy: 'softwareVersion'
          },
          {
            colTitle: 'Found During',
            sortBy: 'foundDuring'
          },
          {
            colTitle: 'Priority',
            sortBy: 'priority'
          },
          {
            colTitle: 'Disposition',
            sortBy: 'selectedDisposition'
          },
          {
            colTitle: 'Status',
            sortBy: 'status'
          },
          {
            colTitle: 'Action',
            sortBy: ''
          },
        ],
        rowData: [],
        filterWords: [
          'QCRnumber',
          'dateCreated',
          'title',
          'foundIn',
          'softwareVersion',
          'foundDuring',
          'priority',
          'selectedDisposition',
          'status',
        ]
      }

    }
  },
  props: 
    {
      loadQCR: 
      {
        id: String,
        
        default: null
      }
    },
  methods: {

    // Toggles between showing all QCRs, pending QCRs, open QCRs, and closed QCRs
    handleToggle: function(type) {
      if (type === 'all') {
        if (this.showAll) {
          this.showOpen = true;
          this.showAll = false;
        } else{
          this.showAll = true;
          this.showPending = false;
          this.showOpen = false;
          this.showClosed = false;
        }       
      } else if(type === 'open') {
        if (this.showOpen) {
          this.showAll = true;
          this.showOpen = false;
        } else {
          this.showOpen = true;
          this.showPending = false;
          this.showAll = false;
          this.showClosed = false;
        }
      } else if (type === 'pending') {
        if (this.showPending) {
          this.showAll = true;
          this.showPending = false;
        } else {
          this.showPending = true;
          this.showAll = false;
          this.showOpen = false;
          this.showClosed = false;
        }
      } else if (type === 'closed') {
        if (this.showClosed) {
          this.showAll = true;
          this.showClosed = false;
        } else {
          this.showClosed = true;
          this.showAll = false;
          this.showOpen = false;
          this.showPending = false;
        }
      }
      if(this.filterVal.findIndex(x => x != '') > -1){
        this.searchFilter();
      } else{
        this.populateQCRData();
      }
    },

    //continue button
    ccbContinue: function(){
      if(this.isPage1){
        this.isPage2 = true;
        this.isPage1 = false;
      }
    },

    //back button
    ccbBack: function(){
      if(this.isPage1){
        this.viewModal = false;
        this.p5_success = false;
        this.p6_success = false;
        this.p5_fail = false;
        this.p6_fail = false;
        this.p7_fail = false;
        this.isPage1 = false;
      } else if(this.isPage2){
        this.isPage2 = false;
        this.isPage1 = true;
      }
    },

    //sets priority value
    setPriority: function(value){
      this.priority = value;
    },

    setProjects: function(value){
      if(value){
        this.projectOptions.forEach(project => {
          if(project.value == value){
            this.foundIn = project.text;
          }
        })
      }
    },

    populateProjects: async function(){
      let token = this.$store.getters.getToken;
      let response = '';
      let query = 'filters[archived][$eq][0]=' + false;      
      try {
          response = await DatabaseLib.getRequest('strapiDatabase','projects',token,query);
      } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p19 = true;
          return;
      }
      this.projectOptions = [];
      for(let c = 0; c < response.data.data.length; c = c + 1){
          let obj = {};
          obj["text"] = response.data.data[c].attributes.ProjectName;
          obj["value"] = response.data.data[c].id;
          obj["version"] = response.data.data[c].attributes.version;

          if (this.foundIn === obj.text)
          {
              obj["selected"] = true;
          }
          this.projectOptions.push(obj);
      }
    },

    //sets filter value
    setVal: function(value){
      let i = 0;
      let choice = "";
      for(var x = 0; x < this.qcrFilterOptions.length; x++){
        i = this.qcrFilterOptions[x].options.findIndex((v => v.value == value));
        if(i >= 0){
          choice = this.qcrFilterOptions[x].options[i].text;
          break;
        }
      }

      let index = this.filterChoices.findIndex((v => v.id == x));
      if(index >= 0){
        this.filterChoices[index].choice = choice
      } else if(x < 7 && x >= 0) {
        this.qcrFilterOptions[x].set = true;
        this.filterChoices.push({id: x, choice: choice, text: ''})
      }
    },

    //sets filter value
    setFilterVal: function(x, val){
      let index = this.filterChoices.findIndex((v => v.id == x));
      if(index >= 0){
        this.filterChoices[index].text = val;
      }
    },

    //sets the selected dispostion
    setDisposition: function(value){
      this.qcrSelectedStatus = "";
      this.dispositionSet = true;
      this.selectedDisposition = value;
      if(value == "Disapproved") {
        this.statusOptions = [{text: "Disapproved", value: "Disapproved"}, {text: "Complete", value: "Complete"}, {text: "OBE", value: "OBE"}];
      } else {
        this.statusOptions = [];
      }
    },
    setStatus: function(value){
      this.qcrSelectedStatus = value;
    },
    // sets QCR number to delete data and restart the CCB process
    ccbInfo: function(data){
      this.qcrId = data.id;
    },

    // adds a filter
    addFilter: function(){
      if(this.filterNumber != 9){
        this.filterNumber++;
      }
    },
    // removes a filter
    removeFilter: function(){
      if(this.filterNumber != 1){
        this.filterNumber--;
        this.filterChoices.splice(this.filterNumber,1)
      }
    },

    //===========================================================================================
    //	Method Name	:	searchFilter
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Searches the QCR table
    //===========================================================================================
    searchFilter: async function(){
      this.$nextTick(function() {
        this.$refs.mainTable.scrollIntoView({behavior: 'smooth'})
      })
      await this.populateQCRData();
      
      let filter_foundDuring = "";
      let filter_foundIn = ""
      let filter_version = "";
      let filter_priority = "";
      let filter_status = "";
      let filter_title = "";
      let filter_disposition = "";
      let filter_qcrNum = "";

      for(var x = 0; x < this.filterChoices.length; x++){
        if(this.filterChoices[x].choice == "QCR Number"){
          filter_qcrNum = this.filterChoices[x].text;
        } else if(this.filterChoices[x].choice == "Found During"){
          filter_foundDuring = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Found In"){
          filter_foundIn = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Version"){
          filter_version = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Priority"){
          filter_priority = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Status"){
          filter_status = this.filterChoices[x].text;
        }else if(this.filterChoices[x].choice == "Title"){
          filter_title = this.filterChoices[x].text;
        } else if(this.filterChoices[x].choice == "Disposition"){
          filter_disposition = this.filterChoices[x].text;
        }
      }

      this.qcrData.rowData = this.qcrData.rowData.filter(qcr =>
        (filter_qcrNum == "" ||
          (qcr.QCRnumber == filter_qcrNum)) &&
        (filter_title == "" ||
          (qcr.title ?? "").toLowerCase().includes(filter_title.toLowerCase())) &&
        (filter_foundDuring == "" ||
          (qcr.foundDuring ?? "").toLowerCase().includes(filter_foundDuring.toLowerCase())) &&
        (filter_foundIn == "" ||
          (qcr.foundIn ?? "").toLowerCase().includes(filter_foundIn.toLowerCase())) &&
        (filter_version == "" ||
          (qcr.softwareVersion ?? "").toLowerCase().includes(filter_version.toLowerCase())) &&
        (filter_priority == "" ||
          qcr.priority == filter_priority) &&
        (filter_disposition == "" ||
          (qcr.selectedDisposition ?? "").toLowerCase().includes(filter_disposition.toLowerCase())) &&
        (filter_status == "" ||
          (qcr.status ?? "").toLowerCase().includes(filter_status.toLowerCase()))
      );

      // pending
      this.pendingQCRs.rowData = this.pendingQCRs.rowData.filter(qcr =>
        (filter_qcrNum == "" ||
          (qcr.QCRnumber == filter_qcrNum)) &&
        (filter_title == "" ||
          (qcr.title ?? "").toLowerCase().includes(filter_title.toLowerCase())) &&
        (filter_foundDuring == "" ||
          (qcr.foundDuring ?? "").toLowerCase().includes(filter_foundDuring.toLowerCase())) &&
        (filter_foundIn == "" ||
          (qcr.foundIn ?? "").toLowerCase().includes(filter_foundIn.toLowerCase())) &&
        (filter_version == "" ||
          (qcr.softwareVersion ?? "").toLowerCase().includes(filter_version.toLowerCase())) &&
        (filter_priority == "" ||
          qcr.priority == filter_priority) &&
        (filter_disposition == "" ||
          (qcr.selectedDisposition ?? "").toLowerCase() == (filter_disposition.toLowerCase())) &&
        (filter_status == "" ||
          (qcr.status ?? "").toLowerCase().includes(filter_status.toLowerCase()))
      );
    },

    //===========================================================================================
    //	Method Name	:	resetFilter
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Resets the QCR table and filter values
    //===========================================================================================
    resetFilter: function(){
      this.filterVal = ["","","","","","","",""];
      this.filterChoices = [];
      this.filterNumber = 1;
      this.filterChoice = '';

      this.qcrFilterOptions = [];
      let options = [];
      for(var i = 0; i < 8; i++){
        options = [{text: "QCR Number", value: "QCRnumber"+i},{text: "Title", value: "title"+i},
          {text:"Found In", value: "foundIn"+i},{text:"Version", value: "version"+i},
          {text: "Found During", value: "foundDuring"+i},{text:"Priority", value: "priority"+i},
          {text: "Disposition", value: "disposition"+i}, {text: "Status", value: "status"+i}];
        this.qcrFilterOptions.push({id: i, options: options, set: false});  
      }

      this.populateQCRData();
    },

    //===========================================================================================
    //	Method Name	:	resetData
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Resets variables
    //===========================================================================================
    resetData: function(){
      this.dispositionSet = false;
      this.alreadyApproved = false;
      this.selectedDisposition = '';
      this.commentsCCB = '';
      this.dateCreated = '';
      this.qprSubmitDate = '';
      this.qcrNumber = '';
      this.qcrId = '';
      this.title = '';
      this.author = '';
      this.foundIn = '';
      this.softwareVersion = '';
      this.foundDuring = '';
      this.currentFunction = '';
      this.expectedFunction = '';
      this.priority = '';
      this.oldPriority = '';
      this.oldFoundIn = '';
      this.status = '';
      this.discussionRequired = '';
      this.statusOptions = [];
      this.QIPNumber = '';
      this.type = '';
      this.companyName = '';
      this.previousStatus = '';
      this.qcrSelectedStatus = '';
      this.approvingPM = '';
      this.qprNumber = '';
      this.pmComments = '';
      this.isPmOnProject = false;
      this.disposition = [{text: "Approved", value: "Approved"},{text:"Disapproved", value: "Disapproved"}];
    },


    //===========================================================================================
    //	Method Name	:	populateQCRData
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Gets the QCRs
    //===========================================================================================
    populateQCRData: async function() {
      this.isSetUp = false;
      let token = this.$store.getters.getToken;

      let ccbs = JSON.parse(this.$store.getters.getCCBGroups);

      const params = {
        showAll: this.showAll,
        showPending: this.showPending,
        showClosed: this.showClosed,
        showOpen: this.showOpen,
        isAdmin: this.isAdmin,
        isCM: this.isCM,
        isDev: this.isDev,
        isPM: this.isPM,
        ccbProjects: ccbs.length > 0 ? ccbs : [],
        pmProjects: this.pmProjects,
        devProjects: this.devProjects
      };
      const data = await DatabaseLib.postRequest('strapiDatabase', 'qcrs/bulk-load',token,params);
      this.pendingQCRs.rowData = data.data.pendingQCRs;
      this.qcrData.rowData = data.data.qcrData;
      this.isSetUp = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    //===========================================================================================
    //	Method Name	:	loadQIP
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Load QIP data for Download or Preview
    //===========================================================================================
    loadQIP: async function(QCRnumber, QIPNumber){
      let token = this.$store.getters.getToken;
      let QIPData = [];
      try{
          let query = "filters[id][$in][0]=" + QIPNumber + "&populate[0]=qipDocs";
          let response = await DatabaseLib.getRequest('strapiDatabase','qip-forms',token,query);
          QIPData = {
            QCRnumber: QCRnumber,
            author1: response.data.data[0].attributes.author1,
            author2: response.data.data[0].attributes.author2,
            introduction: response.data.data[0].attributes.introduction,
            description: response.data.data[0].attributes.description,
            designApproach: response.data.data[0].attributes.designApproach,
            designApproach2: response.data.data[0].attributes.designApproach2,
            userManual: response.data.data[0].attributes.userManual,
            requirements: response.data.data[0].attributes.requirements,
            designDoc: response.data.data[0].attributes.designDoc,
            developmentPlan: response.data.data[0].attributes.developmentPlan,
            testPlan: response.data.data[0].attributes.testPlan,
            fqtProcedure: response.data.data[0].attributes.fqtProcedure,
            testReport: response.data.data[0].attributes.testReport,
            processDoc: response.data.data[0].attributes.processDoc,
            otherDoc: response.data.data[0].attributes.otherDoc,
            resources: response.data.data[0].attributes.resources,
            travel: response.data.data[0].attributes.travel,
            className: response.data.data[0].attributes.className,
            integration: response.data.data[0].attributes.integration,
            externalInterfaces: response.data.data[0].attributes.externalInterfaces,
            internalInterfaces: response.data.data[0].attributes.internalInterfaces,
            reuse: response.data.data[0].attributes.reuse,
            qipDocs: response.data.data[0].attributes.qipDocs.data
          };

          let hasDocs = false;
          if(response.data.data[0].attributes.qipDocs.data != null){
            hasDocs = true;
          }
          
          if(hasDocs){
            let url = DatabaseLib.getEndpoint('strapiDatabase').slice(0, -1) + response.data.data[0].attributes.qipDocs.data.attributes.url;
            const response2 = await fetch(url)
            const blob = await response2.blob()
            QIPDownload(QIPData, blob);
          } else {
            PDFDownload.QIPPreview(QIPData);
          }
      } catch(error) {
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }
      return QIPData;
    },

    //===========================================================================================
    //	Method Name	:	viewQIP
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Load QIP data for Download or Preview
    //===========================================================================================
    viewQIP: async function (data) {
      const token = this.$store.getters.getToken;
      const currentUser = this.$store.getters.getUser;
      let previewOnly = true;
      let CCB2 = false;
      let CCB4 = false;

      // -------------------------
      // 1️⃣ Load Project
      // -------------------------
      const projectQuery = `filters[ProjectName][$eq][0]=${data.foundIn}`;
      const pmForProject = await DatabaseLib.getRequest('strapiDatabase','projects',token,projectQuery,false);
      
      // Get Build info
      if(data.buildNumber){
        const buildQuery = `filters[id][$eq][0]=${data.buildNumber}`;
        const buildData = await DatabaseLib.getRequest('strapiDatabase','builds',token,buildQuery,false);
        CCB2 = buildData.data.data[0].attributes.CCB2;
        CCB4 = buildData.data.data[0].attributes.CCB4;
      }

      const projectData = pmForProject?.data?.data?.[0];
      const isProjectPM =
        projectData &&
        projectData.attributes.ProjectManager === currentUser;

      // -------------------------
      // 2️⃣ Permission Logic
      // -------------------------
      if (this.isAdmin) {
        previewOnly = false;
      }

      // added to give dev access to edit all pending QCRs
      else if(this.isDev && !data.buildNumber && (data.type === 'Pending' || data.type === 'Open')) {
        // no buildNumber, is pending or open, previewOnly = false
        previewOnly = false;
      }

      else if (this.isDev && data.buildNumber) {
        const buildQuery =
          `filters[buildNumber][$eq][0]=${data.buildNumber}` +
          `&filters[username][$eq][1]=${currentUser}`;

        const response = await DatabaseLib.getRequest(
          'strapiDatabase',
          'assigned-builds',
          token,
          buildQuery
        );

        if (response?.data?.data?.length > 0) {
          previewOnly = false;
        }
      }

      else if (this.isPM && isProjectPM) {
        previewOnly = false;
      }

      // -------------------------
      // 3️⃣ Force Preview Rules
      // -------------------------
      const isClosedInvalid =
        data.type === "Closed" &&
        (data.selectedDisposition !== "Approved" ||
          (data.status !== "Working" && data.status !== "Deferred"));

      if (isClosedInvalid) {
        previewOnly = true;
      }

      const noEditPermissions =
        data.status === "Closed" ||
        previewOnly ||
        (!this.isPM && !this.isDev && !this.isAdmin);

      // -------------------------
      // 4️⃣ Preview Mode
      // -------------------------
      if (noEditPermissions) {
        if (data.QIPNumber) {
          return this.loadQIP(data.QCRnumber, data.QIPNumber);
        }

        this.p7 = true;
        window.scroll({ top: 0, behavior: 'smooth' });
        return;
      }

      // -------------------------
      // 5️⃣ Edit Mode Routing
      // -------------------------
      if (!CCB2 || !CCB4) {
        const propData = {
          id: data.buildNumber,
          qcrId: data.id,
          QCRnumber: data.QCRnumber,
          QIPNumber: data.QIPNumber,
          Stage: data.stage,
          editing_QIP1: !CCB2,
          editing_QIP2: !CCB4 && CCB2
        };

        return this.$router.push({
          name: 'QIP-Form',
          params: { loadBuild: propData }
        });
      }

      // -------------------------
      // 6️⃣ Catch All
      // -------------------------
      if (data.QIPNumber) {
        return this.loadQIP(data.QCRnumber, data.QIPNumber);
      }

      this.p7 = true;
      window.scroll({ top: 0, behavior: 'smooth' });
    },


    //===========================================================================================
    //	Method Name	:	sendCCBReminder
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Send email to CCB members
    //===========================================================================================
    sendCCBReminder: async function(){
      let notification = "This is a reminder that QCR #" + this.qcrNumber + " is ready for QCR Disposition CCB.<br>Found In: " + this.foundIn + "<br>Title: " + this.title;
      let token = this.$store.getters.getToken;
      try{
        for (var i = 0; i < this.members.rowData.length; i = i + 1) {
          if((this.members.rowData[i].email != this.$store.getters.getEmail) && this.members.rowData[i].completed == false){
            await sendEmail(this.members.rowData[i].email, "QCR Disposition CCB Reminder", notification, token, "PendingQCR&id="+this.qcrId, []);
          }
        }
        this.p5_success = true;
      } catch(error){
        console.log(error)
        this.p5_fail = true;
      }
    },

    //===========================================================================================
    //	Method Name	:	getCCBMemberData
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Get CCB member data
    //===========================================================================================
    getCCBMemberData: async function () {
      this.members.rowData = [];
      const token = this.$store.getters.getToken;

      try {
        // 1️⃣ Get active users
        const userQuery =
          "filters[blocked][$eq]=false&populate[groups]=true&populate[role]=true";

        const userResponse = await DatabaseLib.getRequest(
          "strapiDatabase",
          "users",
          token,
          userQuery,
          false
        );

        // 2️⃣ Get project with CCB users
        const projectQuery =
          `filters[ProjectName][$eq]=${this.foundIn}&populate[ccb_users]=true`;

        const projectResponse = await DatabaseLib.getRequest(
          "strapiDatabase",
          "projects",
          token,
          projectQuery,
          false
        );

        const project = projectResponse.data.data[0]?.attributes;
        if (!project) return;

        const projectManager = project.ProjectManager;
        const ccbUsers = project.ccb_users.data || [];

        // Create quick lookup set for CCB usernames
        const ccbUsernames = new Set(
          ccbUsers.map(u => u.attributes.username)
        );

        // 3️⃣ Get ALL CCB approvals at once
        const ccbQuery =
          `filters[QCRnumber][$eq]=${this.qcrId}` +
          `&filters[stage][$eq]=CCB1` +
          `&pagination[pageSize]=1000`;

        const ccbResponse = await DatabaseLib.getRequest(
          "strapiDatabase",
          "ccbs",
          token,
          ccbQuery,
          false
        );

        // Map approvals by username for O(1) lookup
        const approvalMap = new Map();
        for (const item of ccbResponse.data.data) {
          const { username, comments, disposition } = item.attributes;

          approvalMap.set(username, {
            comments: comments || "",
            disposition: disposition || ""
          });
        }

        // 4️⃣ Build member list
        for (const user of userResponse.data) {
          if (user.role?.name === "Administrator") continue;

          const isCCB = ccbUsernames.has(user.username);
          const isPM = user.username === projectManager;

          if (!isCCB && !isPM) continue;

          const approvalData = approvalMap.get(user.username);
          let comments = approvalData?.comments || "";
          const approved = approvalData?.disposition || "---";

          if (isPM && this.reasonForReset != ""){
            comments += " " + this.reasonForReset;

          }

          this.members.rowData.push({
            name: `${user.firstName} ${user.lastName}`,
            approved,
            completed: approved !== "---" ? true : false,
            email: user.email,
            comments: comments || ""
          });
        }

      } catch (error) {
        console.error(error);
      }
    },  
  
    //===========================================================================================
    //	Method Name	:	previewQCR
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Loads QCR data to be viewed
    //===========================================================================================
    previewQCR: async function(data) {
      this.p5_success = false;
      this.p6_success = false;
      this.p5_fail = false;
      this.p6_fail = false;
      this.p7_fail = false;
      this.p8_fail = false;
      let token = this.$store.getters.getToken;
      this.isPage1 = true;
      this.viewModal = true;
      this.commentsCCB = "";
      this.qcrId = data.id;
      this.qcrNumber = data.QCRnumber;
      this.title = data.title;
      this.author = data.author;
      this.foundIn = data.foundIn;
      this.softwareVersion = data.softwareVersion;
      this.foundDuring = data.foundDuring;
      this.currentFunction = data.currentFunction;
      this.expectedFunction = data.expectedFunction;
      this.priority = data.priority;
      this.oldPriority = data.priority;
      this.oldFoundIn = data.foundIn;
      this.dateCreated = data.dateCreated;
      this.discussionRequired = data.discussionNeeded;
      this.selectedDisposition = data.selectedDisposition;
      this.alreadyApproved = false;
      this.previousStatus = data.status;
      this.QIPNumber = data.QIPNumber;
      this.type = data.type;
      this.companyName = data.companyName;
      this.approvingPM = data.approvingPM;
      this.qprNumber = data.qprNumber;
      this.pmComments = data.pmComments;
      this.qprSubmitDate = data.qprSubmitDate;
      this.qcrIsPending = data.type == "Pending" ? true : false;
      this.reasonForReset = data.reasonForCCBReset || "";
      this.populateProjects();

      if(JSON.parse(this.$store.getters.getCCBGroups).length > 0 && JSON.parse(this.$store.getters.getCCBGroups.includes(this.foundIn))){
        this.isCCBOnProject = true;
      }

      this.isPmOnProject = this.pmProjects.includes(this.foundIn) ? true : false;
      await this.getCCBMemberData();

      this.priorityOptions = [];
      //set priority dropdown
      for(var i = 0; i < 5; i++){
        let obj = {};
        obj["text"] = (i + 1).toString();
        obj["value"] = (i + 1).toString();
        if (this.priority === obj.value)
        {
            obj["selected"] = true;
        }
        this.priorityOptions.push(obj);
      }

      //Disable approve button if stage is in CCB and user has completed it
      try{
        let query = "filters[QCRnumber][$eq][0]=" + this.qcrId + "&filters[stage][$eq][1]=CCB1&filters[username][$eq][2]=" + this.$store.getters.getUser;
        let response = await DatabaseLib.getRequest('strapiDatabase','ccbs',token,query,false);
        if(response.data.data.length > 0){
          this.alreadyApproved = true;
        }
      } catch(error){
        console.log(error);
        return;
      }
    },

    
      deleteCCBs: async function(id){
        let token = this.$store.getters.getToken;
        let query = "filters[QCRnumber][$eq][0]=" + id;
        let response = await DatabaseLib.getRequest('strapiDatabase','ccbs',token,query,false);
        for (var i = 0; i < response.data.data.length; i = i + 1) {
          await DatabaseLib.deleteRequest('strapiDatabase','ccbs',token,response.data.data[i].id);
        }
      },

    sendQCRBackToCCB: async function() {
      if(this.reasonForReset === ""){
        this.p8_fail = true;
        return;
      }

      this.reasonForReset = sanitizeInput(this.reasonForReset, this.$sanitize);

      const token = this.$store.getters.getToken;
      try {
        let data = {
          data: {
            CCB1: false,
            selectedDisposition: "Pending",
            status: "",
            build: null,
            discussionNeeded: false,
            rejected: false,
            reasonForCCBReset: this.reasonForReset
          }
        }
        await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrId,data);
        this.p5 = true;
      } catch(error) {
        this.p9 = true;
      }
      this.deleteCCBs(this.qcrId);
      this.viewModal = false;
      this.viewReset = false;
      this.resetData();
      if(this.filterVal.findIndex(x => x != '') > -1){
        this.searchFilter();
      } else{
        this.populateQCRData();
      }
      window.scroll({top: 0, behavior: 'smooth'});
    },

    //===========================================================================================
    //	Method Name	:	checkApprovalsRejections
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Check QCR status to see if it is approved or rejected
    //===========================================================================================
    checkApprovalsRejections: async function () {
      const token = this.$store.getters.getToken;

      try {
        // Run all 3 requests in parallel
        const [
          ccbResponse,
          userResponse,
          projectResponse
        ] = await Promise.all([
          DatabaseLib.getRequest(
            "strapiDatabase",
            "ccbs",
            token,
            `filters[QCRnumber][$eq]=${this.qcrId}`,
            false
          ),
          DatabaseLib.getRequest(
            "strapiDatabase",
            "users",
            token,
            "filters[blocked][$eq]=false&populate[groups]=true&populate[role]=true",
            false
          ),
          DatabaseLib.getRequest(
            "strapiDatabase",
            "projects",
            token,
            `filters[ProjectName][$eq]=${this.foundIn}&populate[ccb_users]=true`,
            false
          )
        ]);

        const project = projectResponse.data.data[0]?.attributes;
        if (!project) return;

        const projectManager = project.ProjectManager;

        // Create quick lookup set for CCB users
        const ccbUsernames = new Set(
          (project.ccb_users.data || []).map(u => u.attributes.username)
        );

        // ----------------------------
        // Count total eligible members
        // ----------------------------
        let totalMembers = 0;

        for (const user of userResponse.data) {
          if (user.role?.name === "Administrator") continue;
          const isCCB = ccbUsernames.has(user.username);
          const isPM = user.username === projectManager;

          if (isCCB || isPM) {
            totalMembers++;
          }
        }

        // ----------------------------
        // Count approvals / rejections
        // ----------------------------
        let totalApproved = 0;
        let totalRejected = 0;

        for (const record of ccbResponse.data.data) {
          const disposition = record.attributes.disposition;

          if (disposition === "Approved") totalApproved++;
          else if (disposition === "Disapproved") totalRejected++;
        }

        // ----------------------------
        // Determine final state
        // ----------------------------
        let selectedStatus = this.isPmOnProject ? this.qcrSelectedStatus : this.previousStatus;
        let isApprovedCCB1 = false;
        let isRejectedCCB1 = false;
        let discussionRequired = false;
        let approvedDisposition = "Pending";

        if (totalRejected === totalMembers && totalMembers > 0) {
          isRejectedCCB1 = true;
          approvedDisposition = "Closed";
          selectedStatus = selectedStatus ? selectedStatus : "Disapproved";
        } 
        else if (totalApproved === totalMembers && totalMembers > 0) {
          isApprovedCCB1 = true;
          approvedDisposition = "Approved";
          selectedStatus = "Deferred";
        } 
        else if (totalRejected > 0 && totalApproved > 0) {
          discussionRequired = true;
          approvedDisposition = "Pending";
        }

        // ----------------------------
        // Update QCR
        // ----------------------------
        const data = {
          data: {
            CCB1: isApprovedCCB1,
            rejected: isRejectedCCB1,
            selectedDisposition: approvedDisposition,
            discussionNeeded: discussionRequired,
            status: selectedStatus,
            closed: isRejectedCCB1
          }
        };

        const submission = await DatabaseLib.putRequest(
          "strapiDatabase",
          "qcrs",
          token,
          this.qcrId,
          data
        );

        if (discussionRequired) {
          await this.notifyUsers(submission);
        }

        this.previewing = false;
        if(this.filterVal.findIndex(x => x != '') > -1){
          this.searchFilter();
        } else{
          this.populateQCRData();
        }

      } catch (error) {
        console.error(error);
      }
    },

    //===========================================================================================
    //	Method Name	:	markCCB1Complete
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Handles CCB users selecting a disposition
    //===========================================================================================
    markCCB1Complete: async function(statusOfQCR){
      let token = this.$store.getters.getToken;
      let status = "Deferred";
      if(statusOfQCR == "Disapproved"){status = this.previousStatus != "" ? this.previousStatus : "Disapproved";}
      let data = {
        data: {
          CCB1: statusOfQCR == "Disapproved" ? false : true,
          rejected: statusOfQCR == "Disapproved" ? true : false,
          selectedDisposition: statusOfQCR == "Disapproved" ? "Closed": statusOfQCR,
          discussionNeeded: false,
          status: status,
          closed: statusOfQCR == "Disapproved" ? true : false
        }
      }
      try{
        await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrId,data);
      }catch(error){
        this.p6 = true;
        return;
      }
      this.p5 = true;
      this.viewModal = false;
      this.resetData();
      if(this.filterVal.findIndex(x => x != '') > -1){
        this.searchFilter();
      } else{
        this.populateQCRData();
      }
      window.scroll({top: 0, behavior: 'smooth'});
    },

    //===========================================================================================
    //	Method Name	:	discussQCR
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Handles rejected QCRs
    //===========================================================================================
    discussQCR: async function(){
      this.viewModal = false;
      let token = this.$store.getters.getToken;
      let qcr_submission = [];
      try {
        let data = {
          data: {
            selectedDisposition: "Pending",
            discussionNeeded: true
          }
        }
        qcr_submission = await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrId,data);
      } catch(error) {
        this.p4 = true;
        return;
      }
      await this.notifyUsers(qcr_submission);
      this.p3 = true;
      this.resetData();
      if(this.filterVal.findIndex(x => x != '') > -1){
        this.searchFilter();
      } else{
        this.populateQCRData();
      }
      window.scroll({top: 0, behavior: 'smooth'});
    },

    //===========================================================================================
    //	Method Name	:	notifyUsers
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Handles notifications for QCRs pending discussion
    //===========================================================================================
    notifyUsers: async function(qcr_submission){
      let token = this.$store.getters.getToken; 
      let notification = "This is a reminder that QCR #" + this.qcrNumber + " is ready for CCB. Found In: " + this.foundIn;
      let emailNotification = "QCR #" + this.qcrNumber + " - pending discussion.<br>Found In: " + this.foundIn + "<br>Title: " + this.title;
      let emailList = [];
      let data = [];
      let PM_user = "";

      try{
        // Get PM
        let query = "filters[ProjectName][$eq][0]="+ this.foundIn;
        let response = await DatabaseLib.getRequest('strapiDatabase','projects',token,query);
        query = "filters[username][$eq][0]="+ response.data.data[0].attributes.ProjectManager;
        response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
        PM_user = response.data[0].username;
        
        // Get CM
        let pushNotify = false;
        query = "filters[blocked][$eq][0]="+ false + "&populate[1]=groups&populate[2]=role&populate[3]=ccb_projects";
        let userResponse = await DatabaseLib.getRequest('strapiDatabase','users',token,query,false);
        for(let i = 0; i < userResponse.data.length; i = i + 1) {
          pushNotify = false;
          if(userResponse.data[i].username == PM_user){
            pushNotify = true;
          }
          else if(userResponse.data[i].ccb_projects.length > 0 && userResponse.data[i].ccb_projects.find(item => item.ProjectName == this.foundIn) !== undefined){
            pushNotify = true;
          }
          if(pushNotify){
            emailList.push(userResponse.data[i].email)
            data = {
              data:{
                details: notification,
                notified: false,
                username: userResponse.data[i].username,
                userEmail: userResponse.data[i].email,
                type: "QCR"
              }
            }
            let res = await DatabaseLib.postRequest('strapiDatabase','notifications',token,data);
            this.msgIds.push(res.data.data.id);
          }
        }
        //push emails
        try{
          await sendEmail(emailList, "Pending QCR - Discussion Required", emailNotification, token, "PendingQCR&id="+this.qcrId, []);
        } catch(error){
          console.log(error);
        }

        data = {
          data: {
            notifications: this.msgIds
          }
        }
        await DatabaseLib.putRequest('strapiDatabase','qcrs',token,qcr_submission.data.data.id,data);
        // Load notifications
        this.bus.$emit('fireMethod');
      }catch(error){
        console.log(error);
      }
    },

    //===========================================================================================
    //	Method Name	:	setQCRDispositionStance
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Handles CCB users selecting a disposition
    //===========================================================================================
    setQCRDispositionStance: async function(){
      if(!this.dispositionSet || (this.isPmOnProject && this.qcrSelectedStatus == '' && this.selectedDisposition == 'Disapproved')
        || (this.qcrSelectedStatus == '' && this.selectedDisposition == 'Disapproved' && this.discussionRequired && (this.isCM || this.isAdmin))){
        this.p7_fail = true;
        return;
      }
      this.viewModal = false;
      let token = this.$store.getters.getToken;

      this.commentsCCB = sanitizeInput(this.commentsCCB, this.$sanitize);
      this.selectedDisposition = sanitizeInput(this.selectedDisposition, this.$sanitize);
      this.qcrSelectedStatus = sanitizeInput(this.qcrSelectedStatus, this.$sanitize);

      if(!this.discussionRequired){
        try {
          let data = {
            data: {
              username: this.$store.getters.getUser,
              firstLastName: await this.getUsersName(),
              comments: this.commentsCCB,
              QCRnumber: this.qcrId,
              stage: "CCB1",
              disposition: this.selectedDisposition
            }
          }
          
          await DatabaseLib.postRequest('strapiDatabase','ccbs',token,data);
          await this.checkApprovalsRejections();
        } catch(error) {
          this.p2 = true;
          return;
        }
      } else {
        //pending
        try {
          let data = {
            data: {
              CCB1: true,
              rejected: false,
              selectedDisposition: this.selectedDisposition == 'Disapproved' ? "Closed" : this.selectedDisposition,
              discussionNeeded: false,
              status: this.selectedDisposition == 'Disapproved' ? this.qcrSelectedStatus : "Deferred",
              closed: this.selectedDisposition == 'Disapproved' ? true : false
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrId,data);
          // delete notifications
          await this.deleteMsgs();
          if(this.filterVal.findIndex(x => x != '') > -1){
            this.searchFilter();
          } else{
            this.populateQCRData();
          }
        } catch(error) {
          this.p2 = true;
          return;
        }
      }
      this.p1 = true;
      this.resetData();
      window.scroll({top: 0, behavior: 'smooth'});
    },

    
    //===========================================================================================
    //	Method Name	:	deleteMsgs
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Deletes notifications from QCR
    //===========================================================================================
    deleteMsgs: async function(){
      let token = this.$store.getters.getToken;
      //delete notifications
      let query = "filters[id][$in][0]=" + this.qcrId + "&populate[1]=notifications";
      let response = await DatabaseLib.getRequest('strapiDatabase','qcrs',token,query,false);
      for(var i = 0; i < response.data.data[0].attributes.notifications.data.length; i++){
        await DatabaseLib.deleteRequest('strapiDatabase','notifications',token,response.data.data[0].attributes.notifications.data[i].id);
      }

      // remove notifications from QCR
      let data = {
        data: {
          notifications: []
        }
      }
      await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrId,data);
      // Load notifications
      this.bus.$emit('fireMethod');
    },

    //===========================================================================================
    //	Method Name	:	getUsersName
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Get current users name
    //===========================================================================================
    getUsersName: async function(){
      let token = this.$store.getters.getToken;
      let query = "filters[blocked][$eq][0]=" + false + "&filters[username][$eq][1]=" + this.$store.getters.getUser;
      let response = await DatabaseLib.getRequest('strapiDatabase','users',token,query,false);
      if(response.data.length > 0){
        return response.data[0].firstName + " " + response.data[0].lastName;
      }
      return "";
    },

    //===========================================================================================
    //	Method Name	:	submitChanges
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Submits changes made to QCR priority
    //===========================================================================================
    submitChanges: async function(){
      let token = this.$store.getters.getToken;

      this.priority = sanitizeInput(this.priority, this.$sanitize);

      try {
        let data = {
          data: {
            priority: this.priority
          }
        }
        await DatabaseLib.putRequest('strapiDatabase','qcrs',token,this.qcrId,data);

      } catch(error) {
        this.p6_fail = true;
        return;
      }
      this.p6_success = true;
      if(this.filterVal.findIndex(x => x != '') > -1){
        this.searchFilter();
      } else{
        this.populateQCRData();
      }
    },

    submitProductChanges: async function(){
      let token = this.$store.getters.getToken;

      this.foundIn = sanitizeInput(this.foundIn, this.$sanitize);
      try {
        let data = {
          data: {
            foundIn: this.foundIn
          }
        }
        console.log(data);
        await DatabaseLib.putRequest('strapiDatabase','submitted-qpr',token,this.qprNumber,data);

      } catch(error) {
        this.p6_fail = true;
        return;
      }
      this.p6_success = true;
      if(this.filterVal.findIndex(x => x != '') > -1){
        this.searchFilter();
      } else{
        this.populateQCRData();
      }
    },

    //===========================================================================================
    //	Method Name	:	checkGroups
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Determine what groups the user belongs to
    //===========================================================================================
    checkGroups: function(){
      if (this.$store.getters.getGroups.includes("Project Manager")){
        this.isPM = true;
      }
      if (this.$store.getters.getGroups.includes("CM")){
        this.isCM = true;
      }
      if(JSON.parse(this.$store.getters.getCCBGroups).length > 0){
          this.isCCB = true;
        }
      if (this.$store.getters.getRole == "Administrator"){
        this.isAdmin = true;
      }
      if (this.$store.getters.getGroups.includes("Developer")){
        this.isDev = true;
      }
    },

    //===========================================================================================
    //	Method Name	:	getDevAssignedBuilds
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Gets builds assigned to developers
    //===========================================================================================
    getDevAssignedBuilds: async function(){
      let token = this.$store.getters.getToken;
      let query = '';
      let response = '';
      this.pmProjects = [];
      this.devProjects = [];

      if(!this.isAdmin){
        try{
          if(this.isDev){
            query = 'filters[username][$eq][0]=' + this.$store.getters.getUser;
            response = await DatabaseLib.getRequest('strapiDatabase','assigned-builds',token,query,false);
            for(let i = 0; i < response.data.data.length; i = i + 1) {
              this.devProjects.push(response.data.data[i].attributes.buildNumber)
            }
          }
          if(this.isPM){
            query = "filters[ProjectManager][$eq][0]="+this.$store.getters.getUser + "&filters[archived][$eq][0]=false";
            response = await DatabaseLib.getRequest('strapiDatabase','projects',token,query,false);
            for(let i = 0; i < response.data.data.length; i = i + 1) {
              this.pmProjects.push(response.data.data[i].attributes.ProjectName)
            }
          }
        } catch(error){
          return;
        }
      }
    },
    
    //===========================================================================================
    //	Method Name	:	checkPage
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Determine what page the user is on
    //===========================================================================================
    checkPage: async function(){
      let token = this.$store.getters.getToken;
      if(this.$route.name == "ViewQCR"){
        this.showOpen = true;
      } else {
        this.showPending = true;
      }
      await this.getDevAssignedBuilds();
      const id = this.$route.query.id;   
                  
      if (id) {
        this.handleToggle('all');
        let query = "filters[id][$eq][0]=" + id + "&populate[1]=submitted_qpr&populate[2]=build&populate[3]=qip_form";
        const response = await DatabaseLib.getRequest('strapiDatabase','qcrs',token,query,false);
        let qpr = response.data.data[0].attributes.submitted_qpr.data;
        let build = response.data.data[0].attributes.build.data;

        if(response.data.data.length > 0){
          const formatted = response.data.data.map(qcr => ({
            id: qcr.id,
            QCRnumber: qcr.attributes.QCRnumber,
            priority: qcr.attributes.priority,
            CCB1: qcr.attributes.CCB1,
            dateCreated: qcr.attributes.dateCreated,
            title: qpr.attributes.title,
            author: qpr.attributes.author,
            foundIn: qpr.attributes.foundIn,
            softwareVersion: qpr.attributes.softwareVersion,
            foundDuring: qpr.attributes.foundDuring,
            currentFunction: qpr.attributes.currentFunction,
            pmComments: qpr.attributes.pmComments,
            approvingPM: qpr.attributes.approvingPM,
            expectedFunction: qpr.attributes.expectedFunction,
            status: qcr.attributes.status,
            selectedDisposition: qcr.attributes.selectedDisposition,
            discussionNeeded: qcr.attributes.discussionNeeded,
            buildNumber: build ? build.id : null,
            qprNumber: qpr ? qpr.id: null,
            qprSubmitDate: qpr.attributes.dateSubmitted,
            QIPNumber: qcr.attributes.qip_form ? qcr.attributes.qip_form.id : null,
            stage: build ? build.attributes.stage : "",
            companyName: qpr.attributes.company,
            type: !qcr.attributes.CCB1 && !qcr.attributes.rejected && !qcr.attributes.closed ?  "Pending" : qcr.attributes.CCB1 && !qcr.attributes.rejected && !qcr.attributes.closed ? "Open": "Closed"
          }));
          // set filter dropdown and test input          
          this.previewQCR(...formatted);
          const comp = this.$refs.filterDropdown[0];
          if (comp && comp.$el) {
            const input = comp.$el.querySelector('input');
            input.value = 'QCR Number';
            input.dispatchEvent(new Event('input')); 
          }
          this.qcrFilterOptions[0].set = true;
          this.qcrFilterOptions[0].options[0].selected = true;
          this.filterVal[0] = this.qcrNumber;
          this.setVal("QCRnumber0");
          this.setFilterVal(0, this.qcrNumber);
          this.searchFilter();
        }
      } else {
        await this.populateQCRData();
      }
    },
  },

  computed:{
    //===========================================================================================
    //	Method Name	:	getFilterArray
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Builds array of filter options for QCR view
    getFilterArray(){
      let arr = [];
      let options = [];
      for(var i = 0; i < 8; i++){
        options = [{text: "QCR Number", value: "QCRnumber"+i},{text: "Title", value: "title"+i},
          {text:"Found In", value: "foundIn"+i},{text:"Version", value: "version"+i},
          {text: "Found During", value: "foundDuring"+i},{text:"Priority", value: "priority"+i},
          {text: "Disposition", value: "disposition"+i}, {text: "Status", value: "status"+i}];
        arr.push({id: i, options: options, set: false});  
      }
      return arr
    },
  },
   watch: {
    viewModal: function() {
      if(!this.viewModal){
        this.isPage1 = false;
        this.isPage2 = false;
      }
    },
  },

  beforeMount(){
    this.qcrFilterOptions = this.getFilterArray;
  },

  mounted() {
    this.checkGroups();
    this.checkPage();
    window.scroll({top: 0, behavior: 'smooth'});
  }
}
</script>
